export default "__VITE_ASSET__97060199__"